module.exports = __webpack_public_path__ + "assets/img/download.44999a77.png";